export default __webpack_public_path__ + "static/media/pending.baddd67d.svg";